/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import {
  DEPLOYMENTS_REQUEST,
  DEPLOYMENTS_SUCCESS,
  DeploymentsRequestAction,
  DeploymentsSuccessAction,
} from 'modules/loaders';
// eslint-disable-next-line no-restricted-imports
import { DeploymentsResponse } from 'types';
// eslint-disable-next-line no-restricted-imports
import { createReducer } from 'util/reducers';

// Action types

export interface DeploymentsState {
  loading: boolean;
  heads: DeploymentsResponse;
}

// Reducer
const initialState: DeploymentsState = {
  loading: false,
  heads: {},
};

export default createReducer(initialState, {
  [DEPLOYMENTS_REQUEST](state, { payload }: DeploymentsRequestAction) {
    return {
      loading: true,
      heads: state.heads,
    };
  },
  [DEPLOYMENTS_SUCCESS](state, { payload }: DeploymentsSuccessAction) {
    return {
      loading: false,
      heads: payload,
    };
  },
});



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/models/deployments.ts